module.exports = __webpack_public_path__ + "9d2c43d6191db55b20bc565d01b16118.png";


//////////////////
// WEBPACK FOOTER
// ./web/images/endless_possibilities/testimonials.png
// module id = 589
// module chunks = 0